<template>
  <div class="google-launcher" aria-label="Google サービス">
    <button
      type="button"
      class="google-launcher-button"
      aria-label="Google サービスを開く"
      @click="isOpen = !isOpen"
    >
      <i class="fab fa-google"></i>
    </button>
    <div v-if="isOpen" class="google-services-panel">
      <p class="google-panel-title">Google サービス</p>
      <div class="google-services-grid">
        <a
          v-for="service in googleServices"
          :key="service.name"
          :href="service.url"
          target="_blank"
          rel="noopener noreferrer"
          class="google-service-link"
        >
          <img
            :src="service.iconUrl"
            :alt="`${service.name} アイコン`"
            class="google-service-icon"
            loading="lazy"
          />
          <span class="google-service-name">{{ service.name }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import type { GoogleService } from "@/types/models";

const isOpen = ref(false);

const googleServices: GoogleService[] = [
  {
    name: "アカウント",
    url: "https://myaccount.google.com",
    iconUrl:
      "https://www.google.com/s2/favicons?domain=myaccount.google.com&sz=64",
  },
  {
    name: "ドライブ",
    url: "https://drive.google.com",
    iconUrl: "https://www.google.com/s2/favicons?domain=drive.google.com&sz=64",
  },
  {
    name: "Gmail",
    url: "https://mail.google.com",
    iconUrl: "https://www.google.com/s2/favicons?domain=mail.google.com&sz=64",
  },
  {
    name: "YouTube",
    url: "https://www.youtube.com",
    iconUrl: "https://www.google.com/s2/favicons?domain=youtube.com&sz=64",
  },
  {
    name: "Gemini",
    url: "https://gemini.google.com",
    iconUrl:
      "https://www.google.com/s2/favicons?domain=gemini.google.com&sz=64",
  },
  {
    name: "マップ",
    url: "https://maps.google.com",
    iconUrl: "https://www.google.com/s2/favicons?domain=maps.google.com&sz=64",
  },
  {
    name: "検索",
    url: "https://www.google.com",
    iconUrl: "https://www.google.com/s2/favicons?domain=google.com&sz=64",
  },
  {
    name: "カレンダー",
    url: "https://calendar.google.com",
    iconUrl:
      "https://www.google.com/s2/favicons?domain=calendar.google.com&sz=64",
  },
  {
    name: "ニュース",
    url: "https://news.google.com",
    iconUrl: "https://www.google.com/s2/favicons?domain=news.google.com&sz=64",
  },
  {
    name: "フォト",
    url: "https://photos.google.com",
    iconUrl:
      "https://www.google.com/s2/favicons?domain=photos.google.com&sz=64",
  },
  {
    name: "Meet",
    url: "https://meet.google.com",
    iconUrl: "https://www.google.com/s2/favicons?domain=meet.google.com&sz=64",
  },
  {
    name: "翻訳",
    url: "https://translate.google.com",
    iconUrl:
      "https://www.google.com/s2/favicons?domain=translate.google.com&sz=64",
  },
];
</script>

<style scoped>
.google-launcher {
  position: relative;
}

.google-launcher-button {
  padding: 6px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background: white;
  color: #5f6368;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.google-launcher-button:hover {
  background: #f5f5f5;
  border-color: #d0d0d0;
}

.google-services-panel {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  padding: 16px;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  min-width: 300px;
  max-width: 450px;
  z-index: 100;
}

.google-panel-title {
  margin: 0 0 12px 0;
  font-size: 12px;
  font-weight: 600;
  color: #202124;
}

.google-services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(70px, 1fr));
  gap: 8px;
}

.google-service-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 8px;
  border-radius: 6px;
  text-decoration: none;
  transition: background 0.2s;
}

.google-service-link:hover {
  background: #f5f5f5;
}

.google-service-icon {
  width: 32px;
  height: 32px;
  border-radius: 4px;
}

.google-service-name {
  font-size: 10px;
  color: #5f6368;
  text-align: center;
  word-break: break-word;
}
</style>
